import { type FC, useEffect, useState } from "react";
import { Heading } from "@stubhub/broadway-web";
import { useContent } from "src/shared/components/content";
import {
  carouselControlButtonRecipe,
  carouselControls,
  carouselImage,
  carouselSection,
  carouselTitle,
  imageCarousel,
} from "./styles";

interface Props {
  images: readonly string[];
  headerContent?: string;
  autoRotate?: boolean;
  imageLabel?: string;
}
export const ImageCarousel: FC<Props> = ({ images, headerContent, autoRotate = false, imageLabel }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const defaultImageAltText = useContent("cid$#4138909#"); // Performer
  const handleImageChange = (index: number) => {
    setCurrentImageIndex(index);
  };

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;

    if (autoRotate && images.length > 1) {
      intervalId = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 5000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [images.length, currentImageIndex, autoRotate]);

  return (
    <div className={imageCarousel}>
      {headerContent && (
        <Heading className={carouselTitle} variant="header" size="small">
          {headerContent}
        </Heading>
      )}

      <div className={carouselSection}>
        {images.map((imageUrl, index) => (
          <img
            key={imageUrl}
            className={carouselImage({ state: index === currentImageIndex ? "active" : "inactive" })}
            src={imageUrl}
            alt={imageLabel ?? defaultImageAltText}
          />
        ))}
      </div>

      {images.length > 1 && (
        <div className={carouselControls}>
          {images.map((imageUrl, index) => (
            <button
              key={imageUrl}
              type="button"
              className={carouselControlButtonRecipe({ state: currentImageIndex === index ? "active" : "inactive" })}
              onClick={() => {
                handleImageChange(index);
              }}
            >
              {" "}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
